/** Mainnet (Arbitrum One) Ostium subgraph endpoint. */
export const DEFAULT_SUBGRAPH_ENDPOINT =
  'https://builder.prod.bedrock.ostium.io/v1/subgraph/gn';

/** Testnet (Arbitrum Sepolia) Ostium subgraph endpoint. */
export const DEFAULT_SUBGRAPH_ENDPOINT_TESTNET =
  'https://api.subgraph.ormilabs.com/api/public/67a599d5-c8d2-4cc4-9c4d-2975a97bc5d8/subgraphs/ost-sep/live/gn';

/** Default Ostium builder API base URL (prices, OHLC, WebSocket stream). */
export const DEFAULT_BUILDER_API_URL = 'https://builder.prod.bedrock.ostium.io';

// ─────────────────────────────────────────────────────────────────────────────
// Client config
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Configuration for {@link OstiumSubgraphClient}.
 *
 * All fields are optional — calling `OstiumSubgraphClient.create()` with no
 * arguments connects to the mainnet subgraph.
 *
 * ```ts
 * // Mainnet (default)
 * const client = OstiumSubgraphClient.create();
 *
 * // Testnet (Arbitrum Sepolia)
 * const client = OstiumSubgraphClient.create({ testnet: true });
 *
 * // Custom endpoints
 * const client = OstiumSubgraphClient.create({
 *   endpoint:      'https://my-subgraph.example.com/graphql',
 *   builderApiUrl: 'https://my-builder-api.example.com',
 * });
 * ```
 */
export interface OstiumSubgraphClientConfig {
  /**
   * Subgraph GraphQL endpoint.
   * When omitted, defaults to the mainnet or testnet subgraph based on `testnet`.
   */
  endpoint?: string;
  /**
   * Use the Arbitrum Sepolia testnet subgraph.
   * Ignored when `endpoint` is set explicitly. Defaults to false (mainnet).
   */
  testnet?: boolean;
  /**
   * Override the builder API base URL used for live prices, OHLC candles, and the
   * WebSocket stream. Defaults to `https://builder.prod.bedrock.ostium.io`.
   */
  builderApiUrl?: string;
  /**
   * Alchemy API key used by `streamAccountUpdates()` for contract-log overlays.
   * Can be overridden per stream call.
   */
  alchemyApiKey?: string;
}
